import { z } from 'zod';

const {
  env: {
    PORT: PORT_ENV,
    INTERNAL_PORT: INTERNAL_PORT_ENV,
    INSPECTOR_PORT: INSPECTOR_PORT_ENV,
    KEEP_ALIVE_TIMEOUT_MS: KEEP_ALIVE_TIMEOUT_MS_ENV,
    SERVER_TIMEOUT_MS: SERVER_TIMEOUT_MS_ENV,
    MAX_EVENT_LOOP_DELAY: MAX_EVENT_LOOP_DELAY_ENV,
    MAX_REQUEST_TIMEOUT: MAX_REQUEST_TIMEOUT_ENV,
    MAX_GRAPHQL_REQUEST_TIMEOUT: MAX_GRAPHQL_REQUEST_TIMEOUT_ENV,
    MAX_REQUEST_TIMEOUT_EXCEPTION: MAX_REQUEST_TIMEOUT_EXCEPTION_ENV,
    MAX_GRAPHQL_REQUEST_TIMEOUT_EXCEPTION:
      MAX_GRAPHQL_REQUEST_TIMEOUT_EXCEPTION_ENV,
    LOMA_URL: LOMA_URL_ENV,
    LOMA_URL_SERVER: LOMA_URL_SERVER_ENV,
    DOGSTATSD_HOST_IP: DD_AGENT_HOST_ENV,
    DOGSTATSD_HOST_PORT: DD_PORT_ENV,
    DOGSTATSD_ENABLED: DD_ENABLED_ENV,
    DD_TRACE_AGENT_PORT: DD_TRACE_AGENT_PORT_ENV,
    GROWTHBOOK_DISABLED: GROWTHBOOK_DISABLED_ENV,
    GROWTHBOOK_KEY: GROWTHBOOK_KEY_ENV,
    GROWTHBOOK_DECRYPTION_KEY: GROWTHBOOK_DECRYPTION_KEY_ENV,
    TITAN_DATA_PLANE_URL: TITAN_DATA_PLANE_URL_ENV,
    CLAIM_PORTAL_URL: CLAIM_PORTAL_URL_ENV,
    NARVAR_PROFILE_URL: NARVAR_PROFILE_URL_ENV,
  },
} = process;

export const PORT = parseInt(PORT_ENV || '3000', 10);

export const INTERNAL_PORT = parseInt(INTERNAL_PORT_ENV || '3001', 10);

export const INSPECTOR_PORT = parseInt(INSPECTOR_PORT_ENV || '3002', 10);

export const KEEP_ALIVE_TIMEOUT_MS = parseInt(
  KEEP_ALIVE_TIMEOUT_MS_ENV || '65000',
  10,
);

export const SERVER_TIMEOUT_MS = parseInt(
  SERVER_TIMEOUT_MS_ENV || '120000',
  10,
);

export const MAX_EVENT_LOOP_DELAY = parseInt(
  MAX_EVENT_LOOP_DELAY_ENV || '2000',
  10,
);

export const MAX_REQUEST_TIMEOUT = parseInt(
  MAX_REQUEST_TIMEOUT_ENV || '10000',
  10,
);

export const MAX_GRAPHQL_REQUEST_TIMEOUT = parseInt(
  MAX_GRAPHQL_REQUEST_TIMEOUT_ENV || '8000',
  10,
);

export const TIMEOUT_EXCEPTION_RETAILERS = ['lenovo-enterprisepro'];

export const MAX_REQUEST_TIMEOUT_EXCEPTION = parseInt(
  MAX_REQUEST_TIMEOUT_EXCEPTION_ENV || '14000',
  10,
);

export const MAX_GRAPHQL_REQUEST_TIMEOUT_EXCEPTION = parseInt(
  MAX_GRAPHQL_REQUEST_TIMEOUT_EXCEPTION_ENV || '13000',
  10,
);

export const LOMA_URL_SERVER =
  LOMA_URL_SERVER_ENV ||
  LOMA_URL_ENV ||
  'https://loma-cdn.domain-cpmt-platform.qa20.narvar.qa/graphql';

export const DATADOG_HOST = DD_AGENT_HOST_ENV || 'localhost';

export const DATADOG_PORT = parseInt(DD_PORT_ENV || '8125', 10) || 8125;

export const DATADOG_ENABLED = Boolean(DD_ENABLED_ENV) || false;

export const DATADOG_TRACE_PORT =
  parseInt(DD_TRACE_AGENT_PORT_ENV || '8126', 10) || 8126;

export const GROWTHBOOK_DISABLED = !!GROWTHBOOK_DISABLED_ENV;
export const GROWTHBOOK_KEY = GROWTHBOOK_KEY_ENV;
export const GROWTHBOOK_DECRYPTION_KEY = GROWTHBOOK_DECRYPTION_KEY_ENV;

export const TITAN_DATA_PLANE_URL = TITAN_DATA_PLANE_URL_ENV;

export const CLAIM_PORTAL_URL = CLAIM_PORTAL_URL_ENV;

export const NARVAR_PROFILE_URL = NARVAR_PROFILE_URL_ENV;

const envSchema = z.object({
  DANGEROUSLY_DOWNGRADE_LOMA_SESSION_COOKIE_SECURITY: z
    .string()
    .optional()
    .transform((v) => v === 'true'),
});

export default envSchema.parse(process.env);
